"use strict";

exports.__esModule = true;
exports.itemConsumer = exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _immer = _interopRequireDefault(require("immer"));

var _context = _interopRequireDefault(require("../context"));

var _component = require("../component");

var _types = require("../Datum/types");

var _utils = require("../Grid/utils");

var _proptypes = require("../utils/proptypes");

var _objects = require("../utils/objects");

var _styles = require("../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _createReactContext = (0, _context.default)(),
    Provider = _createReactContext.Provider,
    Consumer = _createReactContext.Consumer;

var Label =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(Label, _PureComponent);

  function Label() {
    return _PureComponent.apply(this, arguments) || this;
  }

  var _proto = Label.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        width = _this$props.width,
        children = _this$props.children;
    if (children === undefined) return null;
    return _react.default.createElement("div", {
      style: {
        width: width
      },
      className: (0, _styles.formClass)('label')
    }, children);
  };

  return Label;
}(_react.PureComponent); // eslint-disable-next-line


_defineProperty(Label, "propTypes", {
  children: _propTypes.default.any,
  width: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
});

var Item =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Item, _Component);

  function Item(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      inputs: {},
      errors: {}
    };
    _this.events = {
      bindInputToItem: _this.bind.bind(_assertThisInitialized(_assertThisInitialized(_this))),
      unbindInputFromItem: _this.unbind.bind(_assertThisInitialized(_assertThisInitialized(_this))),
      onItemError: _this.handleError.bind(_assertThisInitialized(_assertThisInitialized(_this)))
    };
    _this.handleUpdate = _this.handleUpdate.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    if (props.formDatum) props.formDatum.subscribe(_types.RESET_TOPIC, _this.handleUpdate);
    return _this;
  }

  var _proto2 = Item.prototype;

  _proto2.getErrors = function getErrors() {
    var formDatum = this.props.formDatum;
    var errors = [];

    if (formDatum) {
      Object.keys(this.state.inputs).forEach(function (name) {
        var err = formDatum.getError(name);
        if (err) errors.push(err);
      });
    }

    (0, _objects.objectValues)(this.state.errors).forEach(function (err) {
      if (err) errors.push(err);
    });
    return errors;
  };

  _proto2.handleUpdate = function handleUpdate() {
    var _this2 = this;

    if (this.updateTimer) clearTimeout(this.updateTimer);
    this.updateTimer = setTimeout(function () {
      _this2.forceUpdate();
    });
  };

  _proto2.bind = function bind(name) {
    var _this3 = this;

    var names = Array.isArray(name) ? name : [name];
    var formDatum = this.props.formDatum;

    if (formDatum) {
      names.forEach(function (n) {
        formDatum.subscribe((0, _types.errorSubscribe)(n), _this3.handleUpdate);
      });
    }

    this.setState((0, _immer.default)(function (state) {
      names.forEach(function (n) {
        state.inputs[n] = true;
      });
    }));
  };

  _proto2.unbind = function unbind(name) {
    var names = Array.isArray(name) ? name : [name];
    var formDatum = this.props.formDatum;

    if (formDatum) {
      names.forEach(function (n) {
        formDatum.unsubscribe((0, _types.errorSubscribe)(n));
      });
    }

    this.setState((0, _immer.default)(function (state) {
      names.forEach(function (n) {
        delete state.inputs[n];
      });
    }));
  };

  _proto2.handleError = function handleError(name, error) {
    this.setState((0, _immer.default)(function (state) {
      state.errors[name] = error;
    }));
  };

  _proto2.renderHelp = function renderHelp(errors) {
    if (errors.length > 0) {
      return _react.default.createElement("div", {
        className: (0, _styles.formClass)('error')
      }, errors.map(function (e, i) {
        return _react.default.createElement("div", {
          key: i
        }, e.message);
      }));
    }

    var tip = this.props.tip;
    if (!tip) return null;
    return _react.default.createElement("div", {
      className: (0, _styles.formClass)('tip')
    }, tip);
  };

  _proto2.render = function render() {
    var _this$props2 = this.props,
        children = _this$props2.children,
        grid = _this$props2.grid,
        label = _this$props2.label,
        labelAlign = _this$props2.labelAlign,
        labelVerticalAlign = _this$props2.labelVerticalAlign,
        labelWidth = _this$props2.labelWidth,
        required = _this$props2.required,
        style = _this$props2.style;
    var errors = this.getErrors();
    var className = (0, _classnames.default)((0, _utils.getGrid)(grid), (0, _styles.formClass)('item', required && 'required', errors.length > 0 && 'invalid', labelVerticalAlign && "label-vertical-align-" + labelVerticalAlign, ['top', 'right', 'left'].indexOf(labelAlign) >= 0 && "label-align-" + labelAlign), this.props.className);
    return _react.default.createElement(Provider, {
      value: this.events
    }, _react.default.createElement("div", {
      className: className,
      style: style
    }, _react.default.createElement(Label, {
      width: labelWidth
    }, label), _react.default.createElement("div", {
      className: (0, _styles.formClass)('control')
    }, children, this.renderHelp(errors))));
  };

  return Item;
}(_component.Component);

Item.propTypes = _objectSpread({}, (0, _proptypes.getProps)(_propTypes.default, 'children', 'grid'), {
  className: _propTypes.default.string,
  // formItemErrors: PropTypes.array,
  label: _propTypes.default.any,
  labelAlign: _propTypes.default.string,
  labelWidth: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  required: _propTypes.default.bool,
  tip: _propTypes.default.any
});
Item.defaultProps = _objectSpread({}, _proptypes.defaultProps, {
  formItemErrors: []
});
var _default = Item; // eslint-disable-next-line

exports.default = _default;

var itemConsumer = function itemConsumer(Origin) {
  return function (props) {
    return _react.default.createElement(Consumer, null, function (events) {
      return _react.default.createElement(Origin, _extends({}, props, events));
    });
  };
};

exports.itemConsumer = itemConsumer;